import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
    CardTitle,
    Progress,
} from 'reactstrap';

import useComplianceCheck from './hooks/useComplianceCheck';

const ComplianceCheckSkeleton = () => (
    <Card className="h-100 mb-0">
        <CardBody>
            <div className="dt-field dt-skeleton mb-4" style={{ width: '40%', height: '24px' }} />
            <div className="dt-field dt-skeleton mb-3" style={{ width: '100%', height: '24px' }} />
            <div className="dt-field dt-skeleton mb-3" style={{ width: '100%', height: '24px' }} />
            <div className="dt-field dt-skeleton mb-4" style={{ width: '100%', height: '24px' }} />
            <div className="dt-field dt-skeleton" style={{ width: '100%', height: '20px' }} />
        </CardBody>
    </Card>
);

const ComplianceCheck = ({
    t,
}) => {
    const {
        data,
        isLoading,
        isFetching,
        isError,
    } = useComplianceCheck({ t });

    if (isLoading || isFetching) {
        return <ComplianceCheckSkeleton />;
    }

    if (isError || !data) {
        return null;
    }

    const {
        uploadedDocuments = 0,
        processed = 0,
        issuesFound = 0,
        processingPercentage = 0,
    } = data;

    const percentage = Number(processingPercentage) || 0;

    const stats = [
        {
            key: 'uploadedDocuments',
            label: t('Uploaded Documents'),
            value: uploadedDocuments,
        },
        {
            key: 'processed',
            label: t('Processed'),
            value: processed,
        },
        {
            key: 'issuesFound',
            label: t('Issues Found'),
            value: issuesFound,
            color: 'text-danger'
        },
    ];

    return (
        <Card className="h-100 mb-0">
            <CardBody className="d-flex flex-column">
                <CardTitle tag="h6" className="mb-4">
                    {t('PPWR Compliance Check')}
                </CardTitle>

                <div className="flex-grow-1">
                    {stats.map((stat) => (
                        <div
                            key={stat.key}
                            className="d-flex justify-content-between align-items-center mb-3"
                        >
                            <span className={stat.color ? stat.color : ''}>{stat.label}</span>
                            <span className="fw-semibold">
                                {Number(stat.value) || 0}
                            </span>
                        </div>
                    ))}
                </div>

                <div className="mt-auto">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                        <small className="text-success">
                            {t('Processing Documents')}
                        </small>
                        <small>
                            {`${percentage}%`}
                        </small>
                    </div>

                    <Progress
                        color="success"
                        value={percentage}
                    />
                </div>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(ComplianceCheck);
